module.exports = __webpack_public_path__ + "static/media/plus.5cf7ec20.svg";